// Spelman College's undergraduate majors (#2652). Read on 2026-10-01 from
// Spelman's Majors and CIP Codes list (Institutional Research, updated
// 7/13/2026), the PDF linked from the Majors, Minors and Programs page, which
// gives each of the 34 majors its degree code and academic division. Majors
// offered as BA/BS appear once per degree; the Independent Major has its
// own group because the list gives its division as focus-dependent. The
// Human Services note and the Independent Major note quote the Majors, Minors
// and Programs page ("Pauline E. Drake (PED) Students only", "By application
// only"). Minors and programs are left out. The KB's majors list was the
// starting point; the official list wins.
const majors = {
    "slug": "spelman-college",
    "read": "2026-10-01",
    "intro": "Every major in Spelman's official Majors and CIP Codes list, grouped by academic division, with the degree it leads to. Minors and programs are left out.",
    "groups": [
        {
            "name": "Arts",
            "source": {
                "label": "Spelman College Majors and CIP Codes (Institutional Research, July 2026)",
                "url": "https://www.spelman.edu/_1_Docs-and-Files/academics/spelman-majors-and-cip-codes-jul2026.pdf"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Dance Performance & Choreography",
                    "degree": "BA"
                },
                {
                    "name": "Documentary Filmmaking",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Photography",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Performance",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Humanities",
            "source": {
                "label": "Spelman College Majors and CIP Codes (Institutional Research, July 2026)",
                "url": "https://www.spelman.edu/_1_Docs-and-Files/academics/spelman-majors-and-cip-codes-jul2026.pdf"
            },
            "majors": [
                {
                    "name": "Comparative Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Literature, Media and Writing (formerly English)",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Natural Sciences & Mathematics",
            "source": {
                "label": "Spelman College Majors and CIP Codes (Institutional Research, July 2026)",
                "url": "https://www.spelman.edu/_1_Docs-and-Files/academics/spelman-majors-and-cip-codes-jul2026.pdf"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer and Information Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Science (Dual Degree Engineering Program)",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Social Sciences & Education",
            "source": {
                "label": "Spelman College Majors and CIP Codes (Institutional Research, July 2026)",
                "url": "https://www.spelman.edu/_1_Docs-and-Files/academics/spelman-majors-and-cip-codes-jul2026.pdf"
            },
            "majors": [
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Education Studies",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Global and Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Human Services",
                    "degree": "BA",
                    "note": "For Pauline E. Drake (PED) students only."
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology & Anthropology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Independent major (any division)",
            "source": {
                "label": "Spelman College Majors and CIP Codes (Institutional Research, July 2026)",
                "url": "https://www.spelman.edu/_1_Docs-and-Files/academics/spelman-majors-and-cip-codes-jul2026.pdf"
            },
            "majors": [
                {
                    "name": "Independent Major",
                    "degree": "BA",
                    "note": "By application only; the degree depends on its focus."
                },
                {
                    "name": "Independent Major",
                    "degree": "BS",
                    "note": "By application only; the degree depends on its focus."
                }
            ]
        }
    ]
};

export default majors;
